import { type CommunityInvitationToken, createCommunityInvitationToken } from 'models';
import { useQuery } from 'query';
import { getInvitationToken } from '../../services';
import { getInvitationTokenQueryKey } from '../keys';

// TODO: Accept the detail query key shape `{ id }` instead of a flattened `{ communityId }`.
export const useInvitationTokenQuery = ({ communityId }: { communityId: string }) =>
  useQuery<CommunityInvitationToken>({
    enabled: Boolean(communityId),
    async queryFn() {
      const response = await getInvitationToken({ routeParams: { id: communityId } });
      return createCommunityInvitationToken(response.data);
    },
    queryKey: getInvitationTokenQueryKey({ id: communityId }),
  });
